"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _AboutCarvana = _interopRequireDefault(require("./AboutCarvana"));

var _Financing = _interopRequireDefault(require("./Financing"));

var _HowItWorks = _interopRequireDefault(require("./HowItWorks"));

var _Search = _interopRequireDefault(require("./Search"));

var _SellTrade = _interopRequireDefault(require("./SellTrade"));

var _InnerDrawer = _interopRequireDefault(require("../../Shared/InnerDrawer"));

var _DrawerTitle = _interopRequireDefault(require("../../Shared/DrawerTitle"));

var _Icons = _interopRequireDefault(require("../../Shared/Icons"));

var _Drawer = _interopRequireDefault(require("../../Shared/Drawer"));

var _MenuProvider = require("../../Shared/MenuProvider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var HamburgerWrapper = _styledComponents.default.div.attrs({
  "data-qa": "hamburger-wrapper"
}).withConfig({
  displayName: "HeaderMenuMobile__HamburgerWrapper",
  componentId: "sc-1n14mfh-0"
})(["display:flex;flex:1;justify-content:flex-end;"]);

var StyledHamburger = _styledComponents.default.div.attrs({
  "data-qa": "styled-hamburger"
}).withConfig({
  displayName: "HeaderMenuMobile__StyledHamburger",
  componentId: "sc-1n14mfh-1"
})(["display:flex;width:20px;height:12px;fill:", ";"], function (props) {
  return props.theme.carvana.blue.dark;
});

var HeaderMenuInnerDrawer = (0, _styledComponents.default)(_InnerDrawer.default).withConfig({
  displayName: "HeaderMenuMobile__HeaderMenuInnerDrawer",
  componentId: "sc-1n14mfh-2"
})([""]);
var HeaderMenuDrawerTitle = (0, _styledComponents.default)(_DrawerTitle.default).withConfig({
  displayName: "HeaderMenuMobile__HeaderMenuDrawerTitle",
  componentId: "sc-1n14mfh-3"
})(["position:relative;z-index:9;"]);

var ExtraSpaceForBottom = _styledComponents.default.div.attrs({
  "data-qa": "extra-space-for-bottom"
}).withConfig({
  displayName: "HeaderMenuMobile__ExtraSpaceForBottom",
  componentId: "sc-1n14mfh-4"
})(["height:60px;"]);

var _ref3 = _react.default.createElement(_Icons.default, {
  iconName: "hamburger"
});

var _ref4 = _react.default.createElement(_Search.default, null);

var _ref5 = _react.default.createElement(_SellTrade.default, null);

var _ref7 = _react.default.createElement(_HowItWorks.default, null);

var _ref8 = _react.default.createElement(_AboutCarvana.default, null);

var _ref9 = _react.default.createElement(ExtraSpaceForBottom, null);

var HeaderMenuMobile = function HeaderMenuMobile(_ref) {
  var partner = _ref.partner,
      screenHeight = _ref.screenHeight;

  var _ref6 = _react.default.createElement(_Financing.default, {
    partner: partner
  });

  return _react.default.createElement(_MenuProvider.MenuContext.Consumer, {
    "data-qa": "header-menu-mobile"
  }, function (_ref2) {
    var isMobileMenuExpanded = _ref2.isMobileMenuExpanded,
        setMobileMenuState = _ref2.setMobileMenuState;
    return _react.default.createElement(_react.Fragment, null, _react.default.createElement(HamburgerWrapper, null, _react.default.createElement(StyledHamburger, {
      "data-cv-test": "headerMobileMenuOpen",
      onClick: function onClick() {
        return setMobileMenuState(!isMobileMenuExpanded);
      }
    }, _ref3)), _react.default.createElement(_Drawer.default, {
      anchor: "right",
      isOpen: isMobileMenuExpanded,
      onTouchMove: function onTouchMove(e) {
        return e.stopPropagation();
      }
    }, _react.default.createElement(HeaderMenuInnerDrawer, {
      screenHeight: screenHeight,
      className: "header-menu-mobile-drawer"
    }, _react.default.createElement(HeaderMenuDrawerTitle, {
      close: function close() {
        return setMobileMenuState(!isMobileMenuExpanded);
      },
      title: "Menu"
    }), _ref4, _ref5, _ref6, _ref7, _ref8, _ref9)));
  });
};

HeaderMenuMobile.defaultProps = {
  partner: {
    partnerVanityUrlName: 'notused'
  }
};
var _default = HeaderMenuMobile;
exports.default = _default;
module.exports = exports.default;